export const coursesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_2090_17852)">
      <path
        d="M14.8717 11.8475L11.2108 10.2708C10.43 9.935 9.53417 9.935 8.75417 10.2725L5.11667 11.8475C4.51417 12.1083 4.14 12.6783 4.13917 13.3342C4.13833 13.99 4.51167 14.5608 5.1125 14.8233L6.66667 15.5017V17.6617C6.66667 18.4733 7.14167 19.2167 7.87833 19.5558C8.51917 19.8508 9.2325 20 10 20C10.7675 20 11.4808 19.85 12.1233 19.5558C12.8583 19.2167 13.3333 18.4725 13.3333 17.6617V15.495L14.1667 15.1333V17.5008C14.1667 17.9617 14.5392 18.3342 15 18.3342C15.4608 18.3342 15.8333 17.9617 15.8333 17.5008C15.8333 17.5008 15.8333 13.3783 15.8333 13.3342C15.8333 12.6867 15.4658 12.1025 14.8717 11.8483V11.8475ZM9.41667 11.8025C9.77667 11.6458 10.1917 11.6458 10.5517 11.8008L14.1767 13.2817C14.1767 13.2933 14.1708 13.3025 14.17 13.3142L10.5575 14.8833C10.1942 15.0408 9.7775 15.0408 9.41417 14.8817L5.77833 13.3775L9.41583 11.8025H9.41667ZM11.6667 17.6608C11.6667 17.8267 11.5742 17.9733 11.4258 18.0417C10.5842 18.4275 9.415 18.4275 8.575 18.0417C8.42583 17.9733 8.33333 17.8267 8.33333 17.6608V16.2283L8.74833 16.4092C9.1425 16.5808 9.565 16.6667 9.98833 16.6667C10.4092 16.6667 10.83 16.5817 11.2225 16.4108L11.6667 16.2175V17.6608ZM5.83333 3.75C5.83333 4.44 5.27333 5 4.58333 5C3.89333 5 3.33333 4.44 3.33333 3.75C3.33333 3.06 3.89333 2.5 4.58333 2.5C5.27333 2.5 5.83333 3.06 5.83333 3.75ZM9.16667 3.75C9.16667 4.44 8.60667 5 7.91667 5C7.22667 5 6.66667 4.44 6.66667 3.75C6.66667 3.06 7.22667 2.5 7.91667 2.5C8.60667 2.5 9.16667 3.06 9.16667 3.75ZM15.8333 0H4.16667C1.86917 0 0 1.86917 0 4.16667V14.1667C0 16.4642 1.86917 18.3333 4.16667 18.3333C4.62667 18.3333 5 17.9608 5 17.5C5 17.0392 4.62667 16.6667 4.16667 16.6667C2.78833 16.6667 1.66667 15.545 1.66667 14.1667V7.5H18.3333V14.1667C18.3333 14.7758 18.1117 15.3633 17.7092 15.8192C17.405 16.1642 17.4375 16.6908 17.7833 16.995C18.1267 17.2992 18.6542 17.2675 18.9592 16.9208C19.6308 16.1608 20 15.1817 20 14.1658V4.16667C20 1.86917 18.1308 0 15.8333 0ZM1.66667 5.83333V4.16667C1.66667 2.78833 2.78833 1.66667 4.16667 1.66667H15.8333C17.2117 1.66667 18.3333 2.78833 18.3333 4.16667V5.83333H1.66667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2090_17852">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)

export const editIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_2090_12665)">
      <path
        d="M15.2353 0.765303C14.7821 0.312767 14.1678 0.0585938 13.5273 0.0585938C12.8869 0.0585938 12.2726 0.312767 11.8193 0.765303L0.976677 11.608C0.666178 11.9167 0.419985 12.284 0.252342 12.6885C0.0846994 13.093 -0.00106532 13.5268 9.98748e-06 13.9646V15.3333C9.98748e-06 15.5101 0.0702479 15.6797 0.195272 15.8047C0.320296 15.9297 0.489866 16 0.666677 16H2.03534C2.47319 16.0012 2.90692 15.9156 3.31145 15.748C3.71597 15.5805 4.08325 15.3344 4.39201 15.024L15.2353 4.18064C15.6877 3.72743 15.9417 3.11328 15.9417 2.47297C15.9417 1.83266 15.6877 1.21851 15.2353 0.765303ZM3.44934 14.0813C3.07335 14.4548 2.56532 14.6651 2.03534 14.6666H1.33334V13.9646C1.33267 13.7019 1.38411 13.4417 1.4847 13.1989C1.58529 12.9562 1.73302 12.7359 1.91934 12.5506L10.148 4.32197L11.6813 5.8553L3.44934 14.0813ZM14.292 3.23797L12.6213 4.9093L11.088 3.3793L12.7593 1.70797C12.86 1.60751 12.9795 1.52786 13.111 1.47358C13.2424 1.41929 13.3833 1.39143 13.5255 1.39158C13.6678 1.39174 13.8086 1.41991 13.9399 1.47448C14.0712 1.52905 14.1905 1.60896 14.291 1.70964C14.3915 1.81032 14.4711 1.9298 14.5254 2.06126C14.5797 2.19272 14.6076 2.33359 14.6074 2.47581C14.6072 2.61804 14.5791 2.75885 14.5245 2.89019C14.4699 3.02153 14.39 3.14084 14.2893 3.2413L14.292 3.23797Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2090_12665">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const deleteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.9997 2.66667H11.933C11.7783 1.91428 11.3689 1.23823 10.7738 0.752479C10.1788 0.266727 9.43448 0.000969683 8.66634 0L7.33301 0C6.56487 0.000969683 5.82055 0.266727 5.22551 0.752479C4.63046 1.23823 4.22107 1.91428 4.06634 2.66667H1.99967C1.82286 2.66667 1.65329 2.7369 1.52827 2.86193C1.40325 2.98695 1.33301 3.15652 1.33301 3.33333C1.33301 3.51014 1.40325 3.67971 1.52827 3.80474C1.65329 3.92976 1.82286 4 1.99967 4H2.66634V12.6667C2.6674 13.5504 3.01893 14.3976 3.64382 15.0225C4.26871 15.6474 5.11594 15.9989 5.99967 16H9.99967C10.8834 15.9989 11.7306 15.6474 12.3555 15.0225C12.9804 14.3976 13.3319 13.5504 13.333 12.6667V4H13.9997C14.1765 4 14.3461 3.92976 14.4711 3.80474C14.5961 3.67971 14.6663 3.51014 14.6663 3.33333C14.6663 3.15652 14.5961 2.98695 14.4711 2.86193C14.3461 2.7369 14.1765 2.66667 13.9997 2.66667ZM7.33301 1.33333H8.66634C9.07986 1.33384 9.48309 1.46225 9.82075 1.70096C10.1584 1.93967 10.414 2.27699 10.5523 2.66667H5.44701C5.5854 2.27699 5.84094 1.93967 6.1786 1.70096C6.51626 1.46225 6.91949 1.33384 7.33301 1.33333ZM11.9997 12.6667C11.9997 13.1971 11.789 13.7058 11.4139 14.0809C11.0388 14.456 10.5301 14.6667 9.99967 14.6667H5.99967C5.46924 14.6667 4.96053 14.456 4.58546 14.0809C4.21039 13.7058 3.99967 13.1971 3.99967 12.6667V4H11.9997V12.6667Z"
      fill="currentColor"
    />
    <path
      d="M6.66667 12.0003C6.84348 12.0003 7.01305 11.9301 7.13807 11.8051C7.2631 11.68 7.33333 11.5105 7.33333 11.3337V7.33366C7.33333 7.15685 7.2631 6.98728 7.13807 6.86225C7.01305 6.73723 6.84348 6.66699 6.66667 6.66699C6.48986 6.66699 6.32029 6.73723 6.19526 6.86225C6.07024 6.98728 6 7.15685 6 7.33366V11.3337C6 11.5105 6.07024 11.68 6.19526 11.8051C6.32029 11.9301 6.48986 12.0003 6.66667 12.0003Z"
      fill="currentColor"
    />
    <path
      d="M9.33366 12.0003C9.51047 12.0003 9.68004 11.9301 9.80506 11.8051C9.93009 11.68 10.0003 11.5105 10.0003 11.3337V7.33366C10.0003 7.15685 9.93009 6.98728 9.80506 6.86225C9.68004 6.73723 9.51047 6.66699 9.33366 6.66699C9.15685 6.66699 8.98728 6.73723 8.86225 6.86225C8.73723 6.98728 8.66699 7.15685 8.66699 7.33366V11.3337C8.66699 11.5105 8.73723 11.68 8.86225 11.8051C8.98728 11.9301 9.15685 12.0003 9.33366 12.0003Z"
      fill="currentColor"
    />
  </svg>
)

export const plusIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_2091_9707)">
      <path
        d="M11.25 5.25H6.75V0.75C6.75 0.335789 6.41421 0 6 0C5.58579 0 5.25 0.335789 5.25 0.75V5.25H0.75C0.335789 5.25 0 5.58579 0 6C0 6.41421 0.335789 6.75 0.75 6.75H5.25V11.25C5.25 11.6642 5.58579 12 6 12C6.41421 12 6.75 11.6642 6.75 11.25V6.75H11.25C11.6642 6.75 12 6.41421 12 6C12 5.58579 11.6642 5.25 11.25 5.25Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2091_9707">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const linkIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2109_11976)">
      <path
        d="M16.6667 9.16667V15.8333C16.6667 18.1308 14.7975 20 12.5 20H4.16667C1.86917 20 0 18.1308 0 15.8333V7.5C0 5.2025 1.86917 3.33333 4.16667 3.33333H10.8333C11.2933 3.33333 11.6667 3.70667 11.6667 4.16667C11.6667 4.62667 11.2933 5 10.8333 5H4.16667C2.78833 5 1.66667 6.12167 1.66667 7.5V15.8333C1.66667 17.2117 2.78833 18.3333 4.16667 18.3333H12.5C13.8783 18.3333 15 17.2117 15 15.8333V9.16667C15 8.70667 15.3733 8.33333 15.8333 8.33333C16.2933 8.33333 16.6667 8.70667 16.6667 9.16667ZM17.5 0H11.6667C11.2067 0 10.8333 0.373333 10.8333 0.833333C10.8333 1.29333 11.2067 1.66667 11.6667 1.66667H17.155L6.91083 11.9108C6.585 12.2367 6.585 12.7633 6.91083 13.0892C7.07333 13.2517 7.28667 13.3333 7.5 13.3333C7.71333 13.3333 7.92667 13.2517 8.08917 13.0892L18.3333 2.845V8.33333C18.3333 8.79333 18.7067 9.16667 19.1667 9.16667C19.6267 9.16667 20 8.79333 20 8.33333V2.5C20 1.12167 18.8783 0 17.5 0Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2109_11976">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const taskIcon = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_368_7869)">
      <path
        d="M8.80005 1.33333H8.68605C8.41072 0.557333 7.66938 0 6.80005 0H5.46672C4.59738 0 3.85605 0.557333 3.58072 1.33333H3.46672C1.99605 1.33333 0.800049 2.52933 0.800049 4V12.6667C0.800049 14.5047 2.29538 16 4.13338 16H8.13338C9.97138 16 11.4667 14.5047 11.4667 12.6667V4C11.4667 2.52933 10.2707 1.33333 8.80005 1.33333ZM10.1334 12.6667C10.1334 13.7693 9.23605 14.6667 8.13338 14.6667H4.13338C3.03072 14.6667 2.13338 13.7693 2.13338 12.6667V4C2.13338 3.26467 2.73138 2.66667 3.46672 2.66667H4.13338C4.50205 2.66667 4.80005 2.36867 4.80005 2C4.80005 1.63133 5.09872 1.33333 5.46672 1.33333H6.80005C7.16805 1.33333 7.46672 1.632 7.46672 2C7.46672 2.368 7.76472 2.66667 8.13338 2.66667H8.80005C9.53538 2.66667 10.1334 3.26467 10.1334 4V12.6667ZM14.8 0C13.6974 0 12.8 0.897333 12.8 2V12.8953C12.8 13.786 13.1474 14.6233 13.7767 15.2527L14.3287 15.8047C14.4587 15.9347 14.6294 16 14.8 16C14.9707 16 15.1414 15.9347 15.2714 15.8047L15.8234 15.2527C16.4527 14.6233 16.8 13.786 16.8 12.8953V2C16.8 0.897333 15.9027 0 14.8 0ZM15.4667 12.8953C15.4667 13.43 15.258 13.9327 14.8807 14.31L14.8 14.3907L14.7194 14.31C14.342 13.9327 14.1334 13.43 14.1334 12.8953V2C14.1334 1.632 14.432 1.33333 14.8 1.33333C15.168 1.33333 15.4667 1.632 15.4667 2V12.8953ZM7.28472 4.52867C7.54538 4.78933 7.54538 5.21067 7.28472 5.47133L5.83205 6.924C5.55938 7.19667 5.20138 7.33267 4.84338 7.33267C4.48538 7.33267 4.12738 7.19667 3.85472 6.924L2.99605 6.06467C2.73538 5.804 2.73538 5.382 2.99605 5.122C3.25672 4.86133 3.67805 4.86133 3.93872 5.122L4.79738 5.98133C4.81938 6.00333 4.86738 6.00333 4.89005 5.98133L6.34272 4.52867C6.60338 4.268 7.02405 4.268 7.28472 4.52867ZM7.28472 8.52867C7.54538 8.78933 7.54538 9.21067 7.28472 9.47133L5.83205 10.924C5.55938 11.1967 5.20138 11.3327 4.84338 11.3327C4.48538 11.3327 4.12738 11.1967 3.85472 10.924L2.99605 10.0647C2.73538 9.804 2.73538 9.382 2.99605 9.122C3.25672 8.86133 3.67805 8.86133 3.93872 9.122L4.79738 9.98133C4.81938 10.0033 4.86738 10.0033 4.89005 9.98133L6.34272 8.52867C6.60338 8.268 7.02405 8.268 7.28472 8.52867Z"
        fill="#243B78"
      />
    </g>
    <defs>
      <clipPath id="clip0_368_7869">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.800049)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const fileIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_373_2789)">
      <path
        d="M15.3 6.40045C15.175 6.27547 15.0055 6.20526 14.8287 6.20526C14.6519 6.20526 14.4824 6.27547 14.3573 6.40045L7.09601 13.6931C6.78649 14.0027 6.41902 14.2483 6.01459 14.4158C5.61016 14.5834 5.17668 14.6696 4.73892 14.6697C3.85481 14.6697 3.00689 14.3186 2.38168 13.6934C1.75648 13.0683 1.40521 12.2205 1.40514 11.3364C1.40508 10.4522 1.75623 9.60432 2.38135 8.97912L9.41401 1.91778C9.79007 1.54771 10.2971 1.34123 10.8247 1.34332C11.3523 1.3454 11.8578 1.55589 12.2309 1.92892C12.604 2.30195 12.8146 2.80731 12.8168 3.33492C12.819 3.86253 12.6127 4.36964 12.2427 4.74578L5.21001 11.8071C5.08318 11.9286 4.91432 11.9965 4.73868 11.9965C4.56304 11.9965 4.39418 11.9286 4.26735 11.8071C4.14237 11.6821 4.07216 11.5126 4.07216 11.3358C4.07216 11.159 4.14237 10.9895 4.26735 10.8644L10.5287 4.57445C10.6501 4.44871 10.7173 4.28031 10.7158 4.10552C10.7143 3.93072 10.6442 3.76351 10.5206 3.6399C10.397 3.5163 10.2297 3.44619 10.0549 3.44467C9.88015 3.44315 9.71175 3.51034 9.58601 3.63178L3.32468 9.92178C3.13893 10.1075 2.99158 10.328 2.89105 10.5707C2.79052 10.8133 2.73878 11.0734 2.73878 11.3361C2.73878 11.5988 2.79052 11.8589 2.89105 12.1016C2.99158 12.3442 3.13893 12.5647 3.32468 12.7504C3.70576 13.1141 4.21227 13.317 4.73902 13.317C5.26576 13.317 5.77227 13.1141 6.15335 12.7504L13.1853 5.68845C13.7973 5.06065 14.1374 4.21702 14.1317 3.3403C14.1261 2.46358 13.7753 1.62437 13.1553 1.00446C12.5353 0.384561 11.6961 0.0338791 10.8194 0.0283858C9.94265 0.0228925 9.09906 0.36303 8.47135 0.975116L1.43868 8.03645C0.563468 8.91166 0.0717773 10.0987 0.0717773 11.3364C0.0717774 12.5742 0.563468 13.7612 1.43868 14.6364C2.3139 15.5117 3.50094 16.0034 4.73868 16.0034C5.97642 16.0034 7.16347 15.5117 8.03868 14.6364L15.3 7.34578C15.3623 7.28383 15.4117 7.21018 15.4455 7.12906C15.4792 7.04795 15.4965 6.96096 15.4965 6.87312C15.4965 6.78527 15.4792 6.69828 15.4455 6.61717C15.4117 6.53605 15.3623 6.4624 15.3 6.40045Z"
        fill="#000500"
      />
    </g>
    <defs>
      <clipPath id="clip0_373_2789">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const videoIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1897_4914)">
      <path
        d="M12.6667 0H3.33333C1.49533 0 0 1.49533 0 3.33333V8.66667C0 10.5047 1.49533 12 3.33333 12H12.6667C14.5047 12 16 10.5047 16 8.66667V3.33333C16 1.49533 14.5047 0 12.6667 0ZM14.6667 8.66667C14.6667 9.76933 13.7693 10.6667 12.6667 10.6667H3.33333C2.23067 10.6667 1.33333 9.76933 1.33333 8.66667V3.33333C1.33333 2.23067 2.23067 1.33333 3.33333 1.33333H12.6667C13.7693 1.33333 14.6667 2.23067 14.6667 3.33333V8.66667ZM6.66667 14.6667C6.66667 15.4033 6.07 16 5.33333 16C4.59667 16 4 15.4033 4 14.6667C4 13.93 4.59667 13.3333 5.33333 13.3333C6.07 13.3333 6.66667 13.93 6.66667 14.6667ZM10.2193 4.67267L7.55467 3.192C6.592 2.614 5.26133 3.39667 5.29867 4.51933V7.48C5.26067 8.60267 6.592 9.38467 7.55467 8.80733L10.22 7.32667C11.246 6.79667 11.2453 5.202 10.2193 4.67267ZM9.57133 6.16133L6.90667 7.642C6.83 7.68467 6.76467 7.664 6.72333 7.64C6.682 7.61533 6.632 7.568 6.632 7.48067V4.51933C6.632 4.432 6.68133 4.384 6.72333 4.36C6.74733 4.346 6.77933 4.33267 6.81733 4.33267C6.84467 4.33267 6.87467 4.33933 6.90733 4.35733L9.572 5.838C9.65133 5.882 9.668 5.95 9.668 6C9.668 6.05 9.65133 6.118 9.57267 6.162L9.57133 6.16133ZM16 14.666C16 15.0347 15.7013 15.3327 15.3333 15.3327H8.66667C8.29867 15.3327 8 15.0347 8 14.666C8 14.2973 8.29867 13.9993 8.66667 13.9993H15.3333C15.7013 13.9993 16 14.2973 16 14.666ZM2.66667 14.666C2.66667 15.0347 2.368 15.3327 2 15.3327H0.666667C0.298667 15.3327 0 15.0347 0 14.666C0 14.2973 0.298667 13.9993 0.666667 13.9993H2C2.368 13.9993 2.66667 14.2973 2.66667 14.666Z"
        fill="#121212"
      />
    </g>
    <defs>
      <clipPath id="clip0_1897_4914">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const pauseIcon = (
  <svg
    width="16px"
    height="16px"
    viewBox="-1 0 8 8"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#e23c3c"
    stroke="#e23c3c"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <defs> </defs>{" "}
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        {" "}
        <g
          id="Dribbble-Light-Preview"
          transform="translate(-227.000000, -3765.000000)"
          fill="white"
        >
          {" "}
          <g id="icons" transform="translate(56.000000, 160.000000)">
            {" "}
            <path
              d="M172,3605 C171.448,3605 171,3605.448 171,3606 L171,3612 C171,3612.552 171.448,3613 172,3613 C172.552,3613 173,3612.552 173,3612 L173,3606 C173,3605.448 172.552,3605 172,3605 M177,3606 L177,3612 C177,3612.552 176.552,3613 176,3613 C175.448,3613 175,3612.552 175,3612 L175,3606 C175,3605.448 175.448,3605 176,3605 C176.552,3605 177,3605.448 177,3606"
              id="pause-[#1006]"
            >
              {" "}
            </path>{" "}
          </g>{" "}
        </g>{" "}
      </g>{" "}
    </g>
  </svg>
)
export const sendIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_373_2794)">
      <path
        d="M3.68066 13.2669H7.22866L9.57467 15.6102C9.70075 15.737 9.85064 15.8376 10.0157 15.9062C10.1808 15.9749 10.3579 16.0102 10.5367 16.0102C10.6543 16.01 10.7714 15.995 10.8853 15.9655C11.1155 15.9074 11.3263 15.7897 11.4964 15.6242C11.6666 15.4587 11.7902 15.2513 11.8547 15.0229L15.9927 0.950195L3.68066 13.2669Z"
        fill="white"
      />
      <path
        d="M2.72461 12.3331L15.0479 0.0078125L0.985275 4.15515C0.756299 4.22026 0.548327 4.34412 0.381992 4.51442C0.215658 4.68472 0.0967413 4.89556 0.0370405 5.126C-0.0226602 5.35645 -0.0210703 5.5985 0.0416524 5.82815C0.104375 6.05779 0.226051 6.26704 0.394608 6.43515L2.72461 8.76315V12.3331Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_373_2794">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export const micPermissionIcon = (
  <svg
    width="80px"
    height="80px"
    viewBox="-2.88 -2.88 29.76 29.76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0">
      <rect
        x="-2.88"
        y="-2.88"
        width="29.76"
        height="29.76"
        rx="14.88"
        fill="#E6F9F4"
        strokeWidth="0"
      ></rect>
    </g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2a3 3 0 0 0-3 3v7a3 3 0 1 0 6 0V5a3 3 0 0 0-3-3zM5 12a1 1 0 1 1 2 0 5 5 0 0 0 10 0 1 1 0 1 1 2 0 7.001 7.001 0 0 1-6 6.93V21a1 1 0 1 1-2 0v-2.07A7.001 7.001 0 0 1 5 12z"
        fill="#29CBA1"
      ></path>
    </g>
  </svg>
)

export const googleMeetIcon = (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z"
        fill="white"
      ></path>{" "}
      <path
        d="M5 23.5601C5 24.3557 5.64998 25.0001 6.45081 25.0001H6.47166C5.65857 25.0001 5 24.3557 5 23.5601Z"
        fill="#FBBC05"
      ></path>{" "}
      <path
        d="M17.4678 12.4V16.1596L22.5364 12.0712V8.43999C22.5364 7.6444 21.8864 7 21.0856 7H10.1045L10.0947 12.4H17.4678Z"
        fill="#FBBC05"
      ></path>{" "}
      <path
        d="M17.4671 19.9207H10.0818L10.0732 25.0003H21.085C21.887 25.0003 22.5358 24.3559 22.5358 23.5603V20.2819L17.4671 16.1611V19.9207Z"
        fill="#34A853"
      ></path>{" "}
      <path d="M10.1042 7L5 12.4H10.0956L10.1042 7Z" fill="#EA4335"></path>{" "}
      <path
        d="M5 19.9204V23.56C5 24.3556 5.65857 25 6.47166 25H10.0736L10.0821 19.9204H5Z"
        fill="#1967D2"
      ></path>{" "}
      <path
        d="M10.0956 12.3999H5V19.9203H10.0821L10.0956 12.3999Z"
        fill="#4285F4"
      ></path>{" "}
      <path
        d="M26.9926 22.2796V9.9197C26.7068 8.27931 24.9077 10.1597 24.9077 10.1597L22.5371 12.0713V20.2804L25.9305 23.0392C27.1557 23.2 26.9926 22.2796 26.9926 22.2796Z"
        fill="#34A853"
      ></path>{" "}
      <path
        d="M17.4678 16.1594L22.5377 20.2814V12.0723L17.4678 16.1594Z"
        fill="#188038"
      ></path>{" "}
    </g>
  </svg>
)
export const detailsIcon = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15_845)">
      <path
        d="M15.7998 6.27935C14.7658 4.59535 12.4138 1.77002 8.2858 1.77002C4.1578 1.77002 1.8058 4.59535 0.771801 6.27935C0.452153 6.79636 0.282837 7.39218 0.282837 8.00002C0.282837 8.60786 0.452153 9.20368 0.771801 9.72069C1.8058 11.4047 4.1578 14.23 8.2858 14.23C12.4138 14.23 14.7658 11.4047 15.7998 9.72069C16.1194 9.20368 16.2888 8.60786 16.2888 8.00002C16.2888 7.39218 16.1194 6.79636 15.7998 6.27935ZM14.6631 9.02269C13.7751 10.4667 11.7651 12.8967 8.2858 12.8967C4.80647 12.8967 2.79647 10.4667 1.90847 9.02269C1.71856 8.71538 1.61797 8.36127 1.61797 8.00002C1.61797 7.63877 1.71856 7.28466 1.90847 6.97735C2.79647 5.53335 4.80647 3.10335 8.2858 3.10335C11.7651 3.10335 13.7751 5.53069 14.6631 6.97735C14.853 7.28466 14.9536 7.63877 14.9536 8.00002C14.9536 8.36127 14.853 8.71538 14.6631 9.02269Z"
        fill="#F15824"
      />
      <path
        d="M8.28573 4.6665C7.62646 4.6665 6.98199 4.862 6.43383 5.22827C5.88566 5.59454 5.45842 6.11514 5.20613 6.72423C4.95384 7.33331 4.88783 8.00354 5.01644 8.65014C5.14506 9.29674 5.46253 9.89069 5.9287 10.3569C6.39488 10.823 6.98882 11.1405 7.63543 11.2691C8.28203 11.3977 8.95225 11.3317 9.56134 11.0794C10.1704 10.8271 10.691 10.3999 11.0573 9.85174C11.4236 9.30357 11.6191 8.65911 11.6191 7.99984C11.618 7.11611 11.2665 6.26888 10.6416 5.64398C10.0167 5.01909 9.16946 4.66756 8.28573 4.6665ZM8.28573 9.99984C7.89016 9.99984 7.50349 9.88254 7.17459 9.66278C6.84569 9.44301 6.58934 9.13066 6.43797 8.7652C6.28659 8.39975 6.24699 7.99762 6.32416 7.60966C6.40133 7.22169 6.59181 6.86533 6.87151 6.58562C7.15122 6.30592 7.50759 6.11544 7.89555 6.03827C8.28351 5.9611 8.68564 6.0007 9.05109 6.15208C9.41655 6.30345 9.7289 6.5598 9.94867 6.8887C10.1684 7.2176 10.2857 7.60427 10.2857 7.99984C10.2857 8.53027 10.075 9.03898 9.69994 9.41405C9.32487 9.78912 8.81616 9.99984 8.28573 9.99984Z"
        fill="#F15824"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_845">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.285767)"
        />
      </clipPath>
    </defs>
  </svg>
)
